export default [
  {
    header: 'เอกสาร',
    menu: 'Document',
  },
  {
    title: 'ค้นหาเอกสารทั้งหมด',
    route: null,
    icon: 'MailIcon',
    menu: 'AttachmentSearch',
  },
  {
    title: 'ประวัติการดำเนินการ',
    icon: 'CircleIcon',
    route: 'AttachmentHistory',
    menu: 'AttachmentHistory',
  },
]
